<template>
  <v-container class="text-center">
    <v-row justify="center">
      <v-col cols="12" md="6">
        <base-material-card class="redeemContainer" color="secondary" :title="$t('redeem_voucher')"
          icon="mdi-qrcode-scan justify-center text-center">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-btn class="mx-1" elevation="1" :color="scanQR ? 'error' : 'primary'" @click="switchScan('QR')">
                    <v-icon>mdi-qrcode-scan</v-icon>
                    <span v-if="scanQR">Stop</span>
                  </v-btn>
                  <v-btn class="mx-1" elevation="1" :color="scanGeo ? 'error' : 'primary'" @click="switchScan('GEO')">
                    <v-icon>mdi-earth</v-icon>
                  </v-btn>
                  <v-btn class="mx-1" elevation="1" :color="scanText ? 'error' : 'primary'" @click="switchScan('TEXT')">
                    <v-icon>mdi-lead-pencil</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="scanQR">
                <v-col cols="12">
                  <qrcode-stream class="qrcodeScan" @decode="onDecode" />
                </v-col>
              </v-row>
              <v-row v-if="scanGeo">
                <v-col cols="12">
                  <get-current-position @getPosition="redeemGeo" />
                </v-col>
              </v-row>
              <v-row v-if="scanText">
                <v-col cols="12">
                  <form>
                    <v-text-field v-model="voucherCode" :label="$t('Insert code')" color="secondary" hide-details>
                      <template v-slot:append-outer>
                        <v-btn class="mt-n2" color="primary" elevation="1" fab small @click="manualRedeem">
                          <v-icon>mdi-arrow-right-circle</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Swal from "sweetalert2";
import getCurrentPosition from "@/widget/getCurrentPosition.vue";
import { QrcodeStream } from "vue-qrcode-reader";
export default {
  name: "RedeemQR",
  components: {
    QrcodeStream,
    getCurrentPosition,
  },
  data() {
    return {
      voucherCode: null,
      scanQR: false,
      scanGeo: false,
      scanText: false,
    };
  },
  methods: {
    redeemGeo(coordinates) {
      this.chiamataAxios("POST", "/auth/voucher/redeemGeoVoucher/", {
        dialogLoader: true,
        msg: "none",
        body: { coordX: coordinates.lat, coordY: coordinates.lng },
      }).then((response) => {
        Swal.fire({
          title: response.msg.msgTxt,
          html: response.data && response.data.text ? response.data.text : "",
        });
        //if (response.data && response.data.url) window.open(response.data.url);
      });
    },
    redeemQR(string) {
      this.chiamataAxios("POST", "/auth/voucher/redeemVoucher/" + string, {
        dialogLoader: true,
        msg: "none",
      }).then((response) => {
        Swal.fire({
          title: response.msg.msgTxt,
          html: response.data && response.data.text ? response.data.text : "",
        });
        //if (response.data && response.data.url) window.open(response.data.url);
      });
    },
    switchScan(type) {
      if (type === "QR") this._data.scanQR = !this._data.scanQR;
      else this._data.scanQR = false;
      if (type === "GEO") this._data.scanGeo = !this._data.scanGeo;
      else this._data.scanGeo = false;
      if (type === "TEXT") this._data.scanText = !this._data.scanText;
      else this._data.scanText = false;
    },
    manualRedeem() {
      this.redeemQR(this._data.voucherCode);
      this._data.scanText = false;
    },
    onDecode(decodedString) {
      let voucher = decodedString.replace(/^"(.+(?="$))"$/, "$1");
      this.redeemQR(voucher);
      this._data.scanQR = false;
    },
  },
};
</script>
<style scoped>
.qrcodeScan {
  display: ruby;
}
</style>